<mat-toolbar mat-dialog-actions color="primary">
  <div>
    <div class="title">
      Lista de Compra (Cantidad: {{data.carrito.length}}) | Comercio: {{data.comercio}}
    </div>
  </div>
<!--  <span class="toolbar-space"></span>-->
  <span class="fx-spacer"></span>
  <button mat-icon-button [mat-dialog-close] tabindex="-1">
    <mat-icon>close</mat-icon>
  </button>
</mat-toolbar>
<div class="form-box">
  <table mat-table [dataSource]="dataSource" matSort matSortActive="codigo">
    <ng-container matColumnDef="comercio_identificador">
      <th mat-header-cell *matHeaderCellDef> Identificador Comercio </th>
      <td mat-cell *matCellDef="let e"> {{e.comercio_identificador?e.comercio_identificador:''}} </td>
      <td mat-footer-cell *matFooterCellDef> </td>
    </ng-container>

    <ng-container matColumnDef="codigo">
      <th mat-header-cell *matHeaderCellDef> Codigo Producto </th>
      <td mat-cell *matCellDef="let e"> {{e.codigo}} </td>
      <td mat-footer-cell *matFooterCellDef> </td>
    </ng-container>

    <ng-container matColumnDef="descripcion">
      <th mat-header-cell *matHeaderCellDef> Descripción </th>
      <td mat-cell *matCellDef="let e"> {{e.descripcion}} </td>
      <td mat-footer-cell *matFooterCellDef> Total Gs.</td>
    </ng-container>

    <ng-container matColumnDef="cantidad">
      <th mat-header-cell *matHeaderCellDef> Cantidad </th>
      <td mat-cell *matCellDef="let e"> {{e.cantidad}} </td>
      <td mat-footer-cell *matFooterCellDef>{{ getCantidad() }}</td>
    </ng-container>

    <ng-container matColumnDef="monto">
      <th mat-header-cell *matHeaderCellDef> Importe Gs </th>
      <td mat-cell *matCellDef="let e"> {{(e.monto * e.cantidad | number)}} </td>
      <td mat-footer-cell *matFooterCellDef> {{getTotalCost() | number}} </td>
    </ng-container>


    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
  </table>

  <br>

  <div fxLayout="row" fxLayoutAlign="center center">
    <div mat-dialog-actions>
      <button mat-raised-button [mat-dialog-close] color="primary">
        Cerrar
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

</div>
